import * as _ from "lodash";
import RouteUpdateConstants from "./RouteUpdateConstants.js";
const getDefaultState = () => {
  return {
    routeLocation: {
      key: "",
      pathname: "",
      search: "",
      state: "",
      hash: ""
    }
  };
};
const routeUpdate = (state, actionResult) => {
  let newState = _.cloneDeep(state);
  newState.routeLocation = actionResult.payload;
  return newState;
};
const RouteUpdateReducer = (state = getDefaultState(), actionResult) => {
  switch (actionResult.type) {
    case RouteUpdateConstants.ROUTE_UPDATE:
      return routeUpdate(state, actionResult);
    default:
      return state;
  }
};
const RouteUpdateState = {
  routeState: RouteUpdateReducer
};
export {
  RouteUpdateReducer,
  RouteUpdateState as default,
  getDefaultState
};
//# sourceMappingURL=RouteUpdateReducer.js.map
